import { useState } from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";
import { deletePromoter } from "../../utils/ApiConstant";
import useHttpHook from "../../Hooks/HttpHook";
import ModalWrapper from "../Common/Portals/ModalWrapper";
import { showErrorToast } from "../../utils/notify";

const AssignPromoter = ({
  isLoading,
  isError,
  list,
  setSelectedPromoter,
  selectedPromoters = [],
  getPromoters,
  isActive,
  reSendMail,
  onPromoterDeleted,
}) => {
  const handleSelectPromoter = (id) => {
    if (selectedPromoters.includes(id)) {
      setSelectedPromoter(selectedPromoters.filter((item) => item !== id));
    } else {
      setSelectedPromoter([...selectedPromoters, id]);
    }
  };

  const [loading, sendRequest] = useHttpHook();
  const [deleteModal, setDeleteModal] = useState(false);
  const [promoterId, setPromoterId] = useState(null);

  const deletePromoterById = async () => {
    if (!promoterId) {
      return;
    }
    try {
      const result = await sendRequest(`${deletePromoter}/${promoterId}`, {
        method: "delete",
      });
      if (result?.status !== 1) {
        showErrorToast(result?.message || "Unable to delete promoter");
        return;
      }
      if (typeof setSelectedPromoter === "function") {
        setSelectedPromoter((current) =>
          (current || []).filter((item) => item !== promoterId)
        );
      }
      if (typeof onPromoterDeleted === "function") {
        onPromoterDeleted(promoterId);
      }
      getPromoters();
      setDeleteModal(false);
    } catch (requestError) {
      console.log({ requestError });
      showErrorToast("Unable to delete promoter");
    }
  };

  const items = list?.data?.itemsList || [];

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-promoter-table-panel">
        <div className="event-promoter-table-wrap">
          {list !== null && (
            <MainPagination getEventsMethod={getPromoters} MainData={list}>
              <table
                className="event-promoter-table"
                aria-label={
                  isActive ? "Pending promoters" : "Active promoters"
                }
              >
                <thead>
                  {isActive ? (
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col" className="is-action">
                        Action
                      </th>
                    </tr>
                  ) : (
                    <tr>
                      <th scope="col" className="is-select">
                        Select
                      </th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Username</th>
                      <th scope="col" className="is-action">
                        Action
                      </th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  {items.length > 0 ? (
                    isActive ? (
                      items.map((item, index) => (
                        <tr key={item._id || index}>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td className="is-action">
                            <button
                              type="button"
                              className="event-promoter-resend-btn"
                              onClick={() => reSendMail(item)}
                              disabled={isLoading}
                            >
                              Resend Invitation
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      items.map((item, index) => (
                        <tr key={item._id || index}>
                          <td className="is-select">
                            <label className="event-promoter-check">
                              <input
                                type="checkbox"
                                checked={selectedPromoters.includes(item._id)}
                                onChange={() => handleSelectPromoter(item._id)}
                                aria-label={`Select ${item.firstName} ${item.lastName}`}
                              />
                            </label>
                          </td>
                          <td>
                            {item.firstName} {item.lastName}
                          </td>
                          <td>{item.email}</td>
                          <td>{item.userName}</td>
                          <td className="is-action">
                            <button
                              type="button"
                              className="event-promoter-delete-btn"
                              aria-label={`Delete ${item.firstName} ${item.lastName}`}
                              onClick={() => {
                                setPromoterId(item?._id);
                                setDeleteModal(true);
                              }}
                            >
                              <i
                                className="bi bi-trash-fill"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    )
                  ) : (
                    <tr>
                      <td
                        colSpan={isActive ? 3 : 5}
                        className="event-promoter-empty"
                      >
                        {isActive
                          ? "No pending promoters found."
                          : "No active promoters found."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MainPagination>
          )}
        </div>
      </div>

      {deleteModal && (
        <ModalWrapper
          title="Delete Promoter"
          clickHandler={deletePromoterById}
          CloseModalHandler={() => setDeleteModal(false)}
          dialogClassName="event-promoter-assign-modal-dialog"
          contentClassName="event-promoter-assign-modal"
          headerClassName="event-promoter-assign-modal-header"
          bodyClassName="event-promoter-assign-modal-body"
          footerClassName="event-promoter-assign-modal-footer"
          closeClass="event-promoter-assign-modal-btn-close"
          submitClass="event-promoter-assign-modal-btn-ok"
        >
          <p>Are you sure you want to delete the promoter?</p>
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};

export default AssignPromoter;
